module.exports = "/_next/static/images/854a94554b129f2f8848c9c54179c074-hero-100m-desktop.jpg";